import React, { useContext, useEffect, useState } from "react";
import "./Grid.less";
import chroma from "chroma-js";
import KDTooltip from "../KDTooltip/KDTooltip";
import { colorMap, colors } from "../../helpers/helpers";
const Drag = (props) => {
  const { globalData } = props;
  const data = globalData?.gridPersonInfo.map(({ personInfo }) => personInfo);
  const { gridData } = globalData;
  const { xAxisScales, yAxisScales, colorScheme } = gridData;

  const getListStyle = (el, ind) => ({
    background: el.backColor,
    border: `1px solid transparent`,
    height: `calc((100% - ${(yAxisScales - 1) * 20}px) / ${yAxisScales})`,
    width: `calc((100% - ${(xAxisScales - 1) * 20}px) / ${xAxisScales})`,
    marginTop: ind < xAxisScales ? "0" : "20px",
    marginRight: (ind + 1) % xAxisScales === 0 ? "0" : "20px",
  });

  /**
   * 转换数组
   * [123    [789
   *  456  => 456
   *  789]    123]
   */
  const generateBlocks = () => {
    const arr = Array.from({ lenght: yAxisScales }, () => []);
    for (let i = 0; i < yAxisScales; i++) {
      arr[i] = gridData.gridBlocks.slice(
        i * xAxisScales,
        (i + 1) * xAxisScales
      );
    }
    return arr.reverse().reduce((acc, item) => acc.concat(item));
  };

  const generateTitle = (number, el) => {
    return (
      <>
        <KDTooltip
          tip={el.name.text}
          content={el.name.text}
          style={{ color: el.name.fontColor }}
          className="title-before"
        />
      </>
    );
  };

  const blocks = generateBlocks();
  return (
    <div className="visual-grid-drag-container">
      {blocks.map((el, ind) => (
        <div
          key={el.number}
          className={"drag-group"}
          style={getListStyle(el, ind)}
        >
          <div
            className="drag-anchor"
            style={{
              background:
                colorScheme === "#000000"
                  ? colorMap[
                      colors[`${xAxisScales}-${yAxisScales}`][el.number - 1]
                    ]
                  : colorScheme,
            }}
          >
            {el.customNumber || el.number}
          </div>
          <div className="drag-group-main">
            <div className="drag-group-title-wrapper">
              {generateTitle(el.number, el)}
            </div>

            <div className="drag-group-list" style={{ paddingTop: "0px" }}>
              {data[el.number - 1].map((item, index) => {
                return (
                  <div
                    key={item.personId}
                    className={["drag-item"].join(" ")}
                    style={{ background: "transparent" }}
                  >
                    <div className="drag-item-main">
                      <img src={item.headSculpture} />
                      <KDTooltip
                        tip={item.personName}
                        content={item.personName}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Drag;
